import React, { memo, useMemo } from 'react';
import styles from '../emergencyAlert.module.css';
import TemplateCard from './TemplateCard';
import AIEduSpinner from '../../../components/Spinner/AIEduSpinner';
import ColorPicker from './ColorPicker';

const TemplateGrid = memo(
    ({
        templates,
        selectedTemplate,
        onTemplateSelect,
        selectedBackgroundColor,
        selectedTextColor,
        showTemplatePreview,
        colorOptions,
        selectedColorTemplate,
        colorItemTemplate,
        onBackgroundColorChange,
        onTextColorChange,
        isLoading,
        f,
    }) => {
        // Memoize template cards to prevent unnecessary re-renders
        const templateCards = useMemo(
            () =>
                templates.map((template) => (
                    <TemplateCard
                        key={template.templateId}
                        template={template}
                        isSelected={selectedTemplate === template.templateId}
                        onSelect={onTemplateSelect}
                        selectedBackgroundColor={selectedBackgroundColor}
                        selectedTextColor={selectedTextColor}
                    />
                )),
            [templates, selectedTemplate, onTemplateSelect, selectedBackgroundColor, selectedTextColor]
        );

        // Memoize no data content to prevent recreation
        const noDataContent = useMemo(
            () => (
                <div className={styles.no_data_container}>
                    <div className={styles.no_data_text}>
                        {f({ id: 'AI_EDU_NO_TEMPLATES_AVAILABLE' })}
                    </div>
                </div>
            ),
            [f]
        );

        if (isLoading) {
            return (
                <div className={styles.template_grid_container}>
                    <AIEduSpinner />
                </div>
            );
        }

        return (
            <div style={{ marginLeft: '1.5rem' }}>
                {templates?.length > 0 ? <div className={styles.template_grid}>
                    {templateCards}
                </div> : noDataContent}

                <ColorPicker
                    label={f({ id: 'AI_EDU_BACKGROUND_COLOR' })}
                    selectedColor={selectedBackgroundColor}
                    onColorChange={onBackgroundColorChange}
                    colorOptions={colorOptions}
                    selectedColorTemplate={selectedColorTemplate}
                    colorItemTemplate={colorItemTemplate}
                    f={f}
                />

                <ColorPicker
                    label={f({ id: 'AI_EDU_TEXT_COLOR' })}
                    selectedColor={selectedTextColor}
                    onColorChange={onTextColorChange}
                    colorOptions={colorOptions}
                    selectedColorTemplate={selectedColorTemplate}
                    colorItemTemplate={colorItemTemplate}
                    f={f}
                />
            </div>
        );
    }
);

TemplateGrid.displayName = 'TemplateGrid';

export default TemplateGrid;
